import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "inherit",
    h1: {
      fontFamily: "inherit",
    },
    h2: {
      fontFamily: "inherit",
    },
    h3: {
      fontFamily: "inherit",
    },
    h4: {
      fontFamily: "inherit",
    },
    h5: {
      fontFamily: "inherit",
    },
    h6: {
      fontFamily: "inherit",
    },
  },
});

export default theme;
